import { useCallback, use, useEffect, useRef } from "react";
import { DynamicButtonConfig, ScreenHeaderManagerContext } from "../contexts/ScreenHeaderManager";
import { useFocusEffect, useNavigation } from "@react-navigation/native";
import { Platform } from "react-native";
import ListItem from "../ui_atoms/ListItem";
import { ScreenCardHandle } from "../screens/ScreenCard";
import { useTheme } from "./use-theme";

export const useDynamicHeaderButton = (dynamicButtonConfig?: DynamicButtonConfig | false) => {
    const navigation = useNavigation();
    const { colors } = useTheme();
    const { isScreenScrolled, setIsScreenScrolled, setDynamicButtonConfig } = use(
        ScreenHeaderManagerContext,
    );

    const scrollViewRef = useRef<ScreenCardHandle>(null);

    useFocusEffect(
        useCallback(() => {
            // scrollViewRef needs to stay here to get the latest isScrolled state of the currently focused screen's ScrollView
            if (dynamicButtonConfig && scrollViewRef.current?.isScrolled) {
                setDynamicButtonConfig(dynamicButtonConfig);
                const setConfig = () => {
                    setIsScreenScrolled(true);
                };
                if (Platform.OS !== "ios") {
                    setConfig();
                } else {
                    setTimeout(setConfig, 1); // Keep 1 to avoid a weird animation bug on iOS platform
                }
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [isScreenScrolled, setDynamicButtonConfig, setIsScreenScrolled]),
    );

    useEffect(() => {
        const unsubscribe = navigation.addListener("blur", () => {
            setIsScreenScrolled(false);
            setDynamicButtonConfig(undefined);
        });
        return unsubscribe;
    }, [navigation, setDynamicButtonConfig, setIsScreenScrolled]);

    return dynamicButtonConfig
        ? {
              headerComponent: (
                  <ListItem
                      labels={[{ text: dynamicButtonConfig.title, mode: "cta" }]}
                      onPress={dynamicButtonConfig.onClick}
                      rightIconColor={colors.secondary}
                      {...(dynamicButtonConfig.icon
                          ? {
                                rightIcon: dynamicButtonConfig.icon,
                                rightActionMode: "medium",
                            }
                          : {
                                rightIcon: "add-large",
                                rightActionMode: "action_simple",
                            })}
                  />
              ),
              ref: scrollViewRef,
          }
        : {};
};
